import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const TECH_TYPE = { INTERNAL: "Interno", EXTERNAL: "Eventual / Externo" };
export const AVAIL_STATUS = { disponible: "Disponible", no_disponible: "No disponible", bloqueado: "Bloqueado" };
export const DAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
export const ZONE_MATCH = { exacta: "Zona exacta", cubre: "Cubre la zona", parcial: "Cubre parte de la zona", ninguna: "Fuera de zona" };

export const useList = (url, enabled = true) => {
  const [items, setItems] = useState([]);
  const reload = useCallback(() => (enabled ? api.get(url).then((r) => setItems(r.data)).catch(() => setItems([])) : null), [url, enabled]);
  useEffect(() => { reload(); }, [reload]);
  return [items, reload];
};

export const money = (amount, currency) => (amount === null || amount === undefined ? "—" : `${Number(amount).toLocaleString("es-MX", { minimumFractionDigits: 2 })} ${currency || ""}`);
